import get from 'lodash/get';
import Browser from './Browser';

class Payload {
  static isInHand(serverPayload) {
    const t = get(serverPayload, 'data.actions[0].ads[0].tracking_pixels', false);
    return t && Browser.isUrlInHandPixel(t);
  }
}

export default Payload;
